// WrappedSubNavLinks.tsx
import { BaseNavLink } from "Components/Common/Base";
import { withPermission } from "Components/HOCs/withPermission";

export const ActivityNavLink = withPermission(BaseNavLink, {
    module: "activities",
    parent_model: (props) => props.model,
    skipSubscription: true,
    skipPermission: true,
    hideSubscription: true,
    hidePermission: true,
    action: "activities",
    featureKey: "activities",
    tooltipId: "ActivityNavLink-tooltip",
});

export const NotesNavLink = withPermission(BaseNavLink, {
    module: "notes",
    parent_model: (props) => props.model,
    skipSubscription: true,
    skipPermission: false,
    hideSubscription: true,
    hidePermission: true,
    action: "notes",
    featureKey: "notes",
    tooltipId: "NotesNavLink-tooltip",
});

export const EmailsNavLink = withPermission(BaseNavLink, {
    module: "emails",
    parent_model: (props) => props.model,
    skipSubscription: true,
    skipPermission: false,
    hideSubscription: true,
    hidePermission: true,
    action: "emails",
    featureKey: "emails",
    tooltipId: "EmailsNavLink-tooltip",
});

export const CallNavLink = withPermission(BaseNavLink, {
    module: "calls",
    parent_model: (props) => props.model,
    skipSubscription: true,
    skipPermission: false,
    hideSubscription: true,
    hidePermission: true,
    action: "calls",
    featureKey: "calls",
    tooltipId: "CallNavLink-tooltip",
});

export const TasksNavLink = withPermission(BaseNavLink, {
    module: "tasks",
    parent_model: (props) => props.model,
    skipSubscription: true,
    skipPermission: false,
    hideSubscription: true,
    hidePermission: true,
    action: "tasks",
    featureKey: "tasks",
    tooltipId: "TasksNavLink-tooltip",
});

export const MeetingsNavLink = withPermission(BaseNavLink, {
    module: "meetings",
    parent_model: (props) => props.model,
    skipSubscription: true,
    skipPermission: false,
    hideSubscription: true,
    hidePermission: true,
    action: "meetings",
    featureKey: "meetings",
    tooltipId: "MeetingsNavLink-tooltip",
});

export const WhatsappNavLink = withPermission(BaseNavLink, {
    module: "whatsapp",
    parent_model: (props) => props.model,
    skipSubscription: true,
    skipPermission: false,
    hideSubscription: true,
    hidePermission: true,
    action: "whatsapp",
    featureKey: "whatsapp",
    tooltipId: "WhatsappNavLink-tooltip",
});
